import {
  GET_EVENTS_SUCCESS,
  UPDATE_MAX_SEQUENCES,
  UPDATE_LINES_SUCCESS,
} from 'constants/actionTypes'

import { get } from 'lodash'

const MS_IN_INTERVAL = 10000
const INTERVALS_TO_SAVE = 3
const ZERO = 0
const EMPTY = {}

const initialState = {}

function getMaxSequence(sequences) {
  const latestInterval = Math.max(...Object.keys(sequences))

  return sequences[latestInterval] || ZERO
}

function buildSequence(prevSequences, sequence) {
  const intervalKey = Number.parseInt(Date.now() / MS_IN_INTERVAL, 10)
  const minInterval = intervalKey - INTERVALS_TO_SAVE
  const response = Object.keys(prevSequences).reduce(
    (sequences, interval) => {
      if (interval < minInterval) return sequences

      sequences[interval] = prevSequences[interval]

      return sequences
    },
    { [intervalKey]: sequence },
  )

  return response
}

function setMaxSequences(state, sequences) {
  const response = {}

  if (!sequences) return state

  Object.keys(sequences).forEach((key) => {
    const prevSequences = get(state[key], 'maxSequence', EMPTY)

    response[key] = {
      maxSequence: buildSequence(
        prevSequences,
        sequences[key] || getMaxSequence(prevSequences),
      ),
    }
  })

  return response
}

const handlers = {
  [UPDATE_MAX_SEQUENCES]: (state, payload = {}) =>
    setMaxSequences(state, payload),
  [GET_EVENTS_SUCCESS]: (state, payload = {}) =>
    setMaxSequences(state, payload.maxSequences),
  [UPDATE_LINES_SUCCESS]: (state, payload = {}) =>
    setMaxSequences(state, payload.maxSequences),
}

export default function maxSequences(state = initialState, { type, payload }) {
  return handlers[type] ? handlers[type](state, payload) : state
}
